// extracted by mini-css-extract-plugin
export default {"footerDivider":"SnetFooterCopyright_footerDivider__lau9t","copyrightText":"SnetFooterCopyright_copyrightText__pVnX3"};